export default __webpack_public_path__ + "fd312205169e2e713280b39e0fa2881e.png";